import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.packagings;

export default class Packagings extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      volume: this.number(0),
      count: this.number(0),
      total: this.number(0),
      by: this.string('MIX'),
      notice: this.string(''),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/packagings',
    },
  };
}
